import { createSlice } from '@reduxjs/toolkit'
import { genAgentFormPayload, genConsumerFormPayload, genRequestFormPayload } from 'src/lib/helpers'
import { initialState } from './initialState'

export const payloadSlice = createSlice({
  name: 'payload',
  initialState,
  reducers: {
    setRequestFormPayload: (state, action) => void(genRequestFormPayload(state, action.payload)),
    setAgentFormPayload: (state, action) => void(genAgentFormPayload(state, action.payload)),
    setConsumerFormPayload: (state, action) => void(genConsumerFormPayload(state, action.payload)),
    setAgentDocuments: (state, action) => {
      const allDocs = state.data.formAttachments ? [...state.data.formAttachments, ...action.payload] : []
      const uniqueDocs = allDocs.filter((doc, index, self) => index === self.findIndex((t) => t.name === doc.name))
      state.data.formAttachments = uniqueDocs
    },
    removeDocument: (state, action) => {
      state.data.formAttachments = state.data.formAttachments?.filter((doc) => doc.name !== action.payload)
    }
  }
})

export const { setRequestFormPayload, setAgentFormPayload, setConsumerFormPayload, setAgentDocuments, removeDocument } = payloadSlice.actions

export default payloadSlice.reducer
